export const pendo = window.pendo;
